import { SupplyRequestComponent } from './../../components/supply-request/supply-request.component';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { BehaviorSubject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Filter } from 'src/app/core/models/filter';
import { LoginData } from 'src/app/core/models/login-data';
import { LoginService } from 'src/app/core/services/login.service';
import { ToastService } from 'src/app/core/toast.service';
import { CancelOrderComponent } from '../../components/cancel-order/cancel-order.component';
import { SuppliesOrders } from '../../models/supplies-orders';
import { GetSupplierOrdersService } from '../../services/get-supplier-orders.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { GetDentalSuppliersService } from '../../services/get-dental-suppliers.service';
@Component({
  selector: 'app-my-orders',
  templateUrl: './my-orders.component.html',
  styleUrls: ['./my-orders.component.scss'],
  animations: [
    trigger("openCloseStatus", [
      state('true', style({ height: '*', opacity: '1' })),
      state('false', style({ height: '160px', opacity: '1' })),
      transition("false <=> true", [animate(500)])
    ])
  ],
})
export class MyOrdersComponent implements OnInit {
  columnList = [
    {
      column: "sku",
      title: "Sku",
      operators: [
        { title: "Contains", operator: "_ilike" },
      ],
      type: "text",
    }
  ];
  operatorList = [];
  filterForm = this.fb.group({
    status: [null, [Validators.required]],
    supplier_id: [null, [Validators.required]],
    start: [null, [Validators.required]],
    end: [null, [Validators.required]],
    search: ['', [Validators.required]],
    limit: [10, [Validators.required]],
    offset: [0, [Validators.required]]
  });
  totalElements = 0;
  filterSubject: BehaviorSubject<Filter> = new BehaviorSubject<Filter>(this.filterForm.value);
  /* --------------------------------- FIELDS -------------------------------- */
  // FILTER-FUNCTIONALITIES
  OpenFilter = false;
  openStatus = false;
  displayedColumns: string[] = ['select', 'sNo', 'orderId', 'customerName', 'total_amount', 'contactNumber', 'payment_status', 'action'];
  suppliesOrdersList: SuppliesOrders[];
  statusWiseCount: any;
  selection = new SelectionModel<SuppliesOrders>(true, []);
  loginData: LoginData;
  dentalSuppliersList: any[];
  /* ------------------------------- Constructor ------------------------------ */
  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    private getSupplierOrdersService: GetSupplierOrdersService,
    private toast: ToastService,
    private loginService: LoginService,
    private getDentalSuppliersService: GetDentalSuppliersService
  ) {
    this.loginData = this.loginService.getLoginData();
  }
  /* ----------------------------- NG-LIFE-CYCLES ----------------------------- */
  ngOnInit(): void {
    this.filterSubject.pipe(switchMap(filter => {
      this.suppliesOrdersList = null;
      return this.getSupplierOrdersService.getSuppliesOrders(filter);
    })).subscribe(([supplies_orders, count]: [SuppliesOrders[], number]) => {
      this.suppliesOrdersList = supplies_orders;
      this.totalElements = count;
    });
    this.getDentalSuppliersService.getDentalSuppliers().subscribe(data=>{
      this.dentalSuppliersList = data;
    })
  }
  filterToggleStatus(): void {
    this.openStatus = !this.openStatus;
    // if(this.openStatus && this.filters.length === 0){
    //   this.plusField();
    // }
  }

  setStatus() {
    this.filterSubject.next(this.filterForm.value);
  }
  /* --------------------------------- Getters -------------------------------- */
  cancelOrder(supplyOrder: any) {
    const dialogRef = this.dialog.open(CancelOrderComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'], 
      disableClose: true,
      data: supplyOrder
    });
    dialogRef.afterClosed().subscribe(data => {
      if (data === 'yes') {
        this.filterSubject.next(this.filterForm.value);
      }
    })
  }
  supportRequestDialog(supplyOrder: any) {
    const dialogRef = this.dialog.open(SupplyRequestComponent, {
      width: '40%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'], 
      disableClose: true,
      data: supplyOrder
    });
    dialogRef.afterClosed().subscribe(data => {
      if (data === 'yes') {
      }
    })
  }
  /* ------------------------------- FilterForm ------------------------------- */
  get start() {
    return this.filterForm.get('start');
  }
  get end() {
    return this.filterForm.get('end');
  }
  get status(): AbstractControl {
    return this.filterForm.get("status");
  }
  get supplier_id(): AbstractControl {
    return this.filterForm.get("supplier_id");
  }
  get limit(): AbstractControl {
    return this.filterForm.get('limit');
  }
  get offset(): AbstractControl {
    return this.filterForm.get('offset');
  }
  get filters(): FormArray {
    return this.filterForm.get('filters') as FormArray;
  }
  changePage(e: PageEvent) {
    this.offset.setValue(e.pageSize * e.pageIndex);
    this.filterSubject.next(this.filterForm.value);
  }
  setDateFilter(){
    if(this.start.value && this.end.value){
      this.filterSubject.next(this.filterForm.value);
    }
  }
  clear(){
    this.start.reset(null);
    this.end.reset(null);
    this.filterSubject.next(this.filterForm.value);
  }

  clearFilters(){
    this.start.setValue(null),
    this.end.setValue(null);
    this.status.setValue(null);
    this.supplier_id.setValue(null);
    this.filterSubject.next(this.filterForm.value);
  }

  showClearButton(){
    return this.status.value || this.supplier_id.value || this.start.value || this.end.value;
  }
  viewInvoice(order: SuppliesOrders){
    window.open(`https://dental-360.herokuapp.com/api/v1/event/get-invoice/${order.id}`);
  }
}
